// extracted by mini-css-extract-plugin
export var container = "_71-0";
export var infoButton = "_71-1";
export var label = "_71-3";
export var labelExpanded = "_71-4";
export var price = "_71-5";
export var priceExpanded = "_71-6";
export var title = "_71-2";